import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuditSummaryFormModel } from 'src/app/views/Audit/project-overview/models/audit-summary.model';
import { CategoryReviewerModel } from 'src/app/views/Audit/project-overview/models/category-reviewer.model';
import { CategoryModel } from 'src/app/views/Audit/project-overview/models/category.model';
import { ProjectStatusModel } from 'src/app/views/Audit/project-overview/models/project-status.model';
import { RiskRegisterFormModel } from 'src/app/views/Audit/project-overview/models/risk-register.model';
import { environment } from 'src/environments/environment';
import {CommentsHistoryModel} from 'src/app/views/Audit/project-overview/models/comments-history.model';

@Injectable({
  providedIn: 'root'
})
export class AuditOverviewService {

  private gsdApiUrl = environment.apiUrl;
  private hideSummaryFields = false;
  private selectedStatusIdSource = new BehaviorSubject<number | null>(null);
  selectedStatusId$ = this.selectedStatusIdSource.asObservable();
  private AuditorId = new BehaviorSubject<number>(0); 
  constructor(private http: HttpClient) { }
 
  setAuditorEmployeeId = (id: number) => this.AuditorId.next(id);

  getAuditorId = () => this.AuditorId.asObservable();
  setSelectedStatusId(statusId: number) {
    this.selectedStatusIdSource.next(statusId);
  }
  setHideSummaryFields(value: boolean) {
    this.hideSummaryFields = value;
  }

  getHideSummaryFields(): boolean {
    return this.hideSummaryFields;
  }
  getProjectDetails(auditId:Number){
    const endPointUrl:string = `AuditOverview/ProjectDetailsStatus?auditid=${auditId}`;
    return this.http.get(this.gsdApiUrl+ endPointUrl);
  }


  getStageReviewDetails(auditId: number): Observable<any>
  {
    const endPointUrl:string = `AuditOverview/StageReviewDetails?auditid=${auditId}`;
    return this.http.get(this.gsdApiUrl+ endPointUrl);    
  }

  GetAssignees(auditId: number){
    const endPointUrl:string = `AuditOverview/GetAssignees?auditid=${auditId}`;
    return this.http.get(this.gsdApiUrl+ endPointUrl);
  }

  getCategoryDropDown():Observable<CategoryModel[]>{
    const endPointUrl:string = `AuditOverview/GetCategoryDropdown`;
    return this.http.get<CategoryModel[]>(this.gsdApiUrl + endPointUrl)
  }

  getSubCategoryDropdowns():Observable<any>{
    const endPointUrl: string = `Audit/GetSubCategoriesDropdown`;
    return this.http.get(this.gsdApiUrl+ endPointUrl)
  }

  GetTechnologiesDropdown():Observable<any>{
    const endPointUrl: string = `Audit/GetTechnologiesDropdown`;
    return this.http.get(this.gsdApiUrl+ endPointUrl)
  }

  getSubCategoryDropDown(categoryId:number):Observable<any>{
    const endPointUrl:string = `AuditOverview/GetSubCategoryDropdown?categoryId=${categoryId}`;
    return this.http.get(this.gsdApiUrl+ endPointUrl)
  }

  getQuestionsDropdown(categoryId: number, subcategoryId: number):Observable<any> {
    const endPointUrl: string = `Audit/GetQuestionsDropdownByCategoryIdSubCategoryId?categoryId=${categoryId}&subCategoryId=${subcategoryId}`;
    return this.http.get(this.gsdApiUrl + endPointUrl);
  }
  
  getQuestionsByTehnology(technologyId: number) : Observable<any>{
    const endPointUrl: string = `Audit/GetQuestionsByTechnologyId?technologyId=${technologyId}`;
    return this.http.get(this.gsdApiUrl + endPointUrl);
  }
    
  DeleteQuestion(questionMappingId : number) : Observable<any>{
    const endpointURL: string = `Audit/DeleteQuestion?questionMappingId=${questionMappingId}`;
    return this.http.delete(this.gsdApiUrl + endpointURL, { responseType: 'text' });
  }

  AddorUpdateQuestion(data : any) : Observable<any>{
    const endPointUrl:string = `Audit/AddOrUpdateQuestion`;
    const url = this.gsdApiUrl + endPointUrl;
    return this.http.post(url,data)
  }

  AddNewCategory(data: any) : Observable<any> {
    const endPointUrl:string = `Audit/AddCategory`;
    const url = this.gsdApiUrl + endPointUrl;
    return this.http.post(url,data)
  }

  DeleteCategory(id: number) : Observable<any> {
    const endpointURL: string = `Audit/DeleteCategory?categoryId=${id}`;
    return this.http.delete(this.gsdApiUrl + endpointURL, { responseType: 'text' });
  }

  AddorUpdateTechnologyMapping(data : any) : Observable<any>{
    const endPointUrl:string = `Audit/AddOrUpdateTechnologyMapping`;
    const url = this.gsdApiUrl + endPointUrl;
    return this.http.post(url,data)
  }

  getResponseDropDown():Observable<any>{
    const endPointUrl:string = `AuditOverview/GetResponse`;
    return this.http.get(this.gsdApiUrl+ endPointUrl)
  }

  getFinalReviewRating(auditId:number):Observable<any>{
    const endPointUrl:string = `AuditOverview/GetFinalReviewsRating?auditId=${auditId}`;
    return this.http.get(this.gsdApiUrl+ endPointUrl)
  }

  getComponentDropDown(): Array<any>{
    const componentList: Array<any> = [
      {
        id:1, description:'Few Services'
      },
      {
        id:2, description:'All Services'
      }
    ];
    return componentList;
  }

  // getProjectStatusList():Observable<ProjectStatusModel[]>{
  //   const requestUrl = `${this.gsdApiUrl}AuditOverview/ProjectStatus`;
  //   return this.http.get<ProjectStatusModel[]>(requestUrl);
  // }

  getProjectStatus(auditId: number):Observable<ProjectStatusModel>{
    const endPointUrl = `AuditOverview/GetProjectStatus?auditId=${auditId}`;
    return this.http.get<ProjectStatusModel>(this.gsdApiUrl + endPointUrl);
  }

  getCategoryReviewerDetail(auditId:number, categoryId:number):Observable<CategoryReviewerModel>
  {
    const endpointURL = `AuditOverview/GetCategoryReviewDetails?auditId=${auditId}&categoryId=${categoryId}`;
    return this.http.get<CategoryReviewerModel>(this.gsdApiUrl + endpointURL);
  }

  saveFinalReview(data:any):Observable<any>{
    const url = this.gsdApiUrl + `AuditOverview/SaveFinalReview`;
    return this.http.post(url,data);
  }  

  saveAuditStatus(auditId:number, statusId:number, comment?: string){
    const endpointUrl = `AuditOverview/SaveAuditStatus?auditId=${auditId}&statusId=${statusId}&comment=${comment ?? ""}`;
    return this.http.post(this.gsdApiUrl + endpointUrl,statusId);
  }
  
  clarificationNeededForAuditIdandCategoryId(auditId:number, statusId:number, categoryId:number, comment?: string){
    const endpointUrl = `AuditOverview/ClarificationNeededForAuditIdandCategoryId?auditId=${auditId}&statusId=${statusId}&categoryId=${categoryId}&comment=${comment ?? ""}`;
    return this.http.post(this.gsdApiUrl + endpointUrl,statusId);
  }

  saveAuditSummary(data: any):Observable<any>{
    const url = `${this.gsdApiUrl}AuditOverview/SaveAuditSummary`;
    return this.http.post(url,data);
  }

  saveRiskRegister(data: any):Observable<any>{
    const url = `${this.gsdApiUrl}AuditOverview/SaveRiskRegister`;
    return this.http.post(url,data);
  }

  auditSubmit(data: any):Observable<any>{
    const url = `${this.gsdApiUrl}AuditOverview/{TBD}`;
    return this.http.post(url,data);
  }

  SaveCategoryReviewersDetails(data:any):Observable<any> {
    const endpointUrl = `AuditOverview/SaveCategoryReviewersDetails`;
    return this.http.post(this.gsdApiUrl + endpointUrl,data);
  }

  saveCategoryAssignee(data:any):Observable<any>{
    const endpointUrl = `AuditOverview/SaveCategoryReviewDetails`;
    return this.http.post(this.gsdApiUrl + endpointUrl,data);
  }

  getRiskregister(auditId: number):Observable<RiskRegisterFormModel[]>{
    const requestUrl = `${this.gsdApiUrl}AuditOverview/GetRiskRegisterDetails?auditId=${auditId}`;
    return this.http.get<RiskRegisterFormModel[]>(requestUrl);
  }

  getAuditSummary(auditId: number):Observable<AuditSummaryFormModel[]>{
    const requestUrl = `${this.gsdApiUrl}AuditOverview/GetAuditSummary?auditId=${auditId}`;
    return this.http.get<AuditSummaryFormModel[]>(requestUrl);
  }
  addCommentForStage(auditId: number, stageId: number, comment: string):Observable<any> {
    const requestUrl = `${this.gsdApiUrl}ProjectDetails/AddComment?auditId=${auditId}&stageId=${stageId}&comment=${comment}'`;
    return this.http.post(requestUrl, {});
  }
  getAllCommentsHistory(auditId: number): Observable<CommentsHistoryModel[]>{
    const requestUrl = `${this.gsdApiUrl}ProjectDetails/getCommentsByAuditId?auditId=${auditId}`
    return this.http.get<CommentsHistoryModel[]>(requestUrl);
  }
}